var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoServicesWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Picto Equipamento em Servi\xE7o") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PICTOGRAMAS",
    transform: "translate(-66.000000, -538.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picto-Equipamento-em-Servi\\xE7o",
    transform: "translate(67.000000, 539.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5474937,3.55921519 L15.164962,7.94174684 L11.9388861,4.71567089 L16.3196456,0.334911392 C15.7573671,0.133898734 15.1545823,0.0187088608 14.5231899,0.0187088608 C11.572557,0.0187088608 9.18065823,2.41086076 9.18065823,5.36149367 C9.18065823,5.99263291 9.2958481,6.59567089 9.49686076,7.1576962 L0.678632911,15.9759241 L0.684455696,15.9817468 C0.273316456,16.3931392 0.0188860759,16.9614937 0.0188860759,17.5890886 C0.0188860759,18.8442785 1.03635443,19.8617468 2.2915443,19.8617468 C2.91913924,19.8617468 3.48749367,19.6073165 3.89863291,19.1961772 L3.90470886,19.202 L12.7209114,10.3857975 C13.2847089,10.5880759 13.8897722,10.7040253 14.5231899,10.7040253 C17.4738228,10.7040253 19.8657215,8.31212658 19.8657215,5.36149367 C19.8657215,4.72807595 19.7497722,4.12301266 19.5474937,3.55921519 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5224557,9.35817722 L2.99081013,16.8898228",
    id: "Stroke-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoServicesWhite);
export default __webpack_public_path__ + "static/media/PictoServicesWhite.8371609da03d9af6badba03eafced66b.svg";
export { ForwardRef as ReactComponent };